import gql from 'graphql-tag'

export default gql`
mutation updateBatchTrackingKerry($labelIds: [String!]) {
  updateBatchTrackingKerry(labelIds: $labelIds) {
    _id
    sendHook
  }
}
`


// WEBPACK FOOTER //
// ./src/graphql/mutations/UpdateBatchTrackingKerry.js